module.exports = __webpack_public_path__ + "img/bg.34669f95.png";